import { Profissao } from './profissao';
import { ClasseProfissional } from './classe-profissional';
import { Empresa } from './empresa';
import { Endereco } from '../../../ficha-veiculo/ficha-cadastro/model/endereco-cliente';
import { TempoExperiencia } from './tempo-experiencia';

export class DadosProfissionais {

  classeProfissional: ClasseProfissional;
  profissao: Profissao;
  empresa: Empresa = new Empresa();
  tempoExperiencia: TempoExperiencia;
  familiaresRamo: string;

  private _isSelectDados = false;

  public static of(
    idClasse: number,
    idProfissao: number,
    nomeEmpresa: string,
    telefoneEmpresa: string,
    endereco: Endereco,
    tempoExperienciaRamo?: number,
    possuiFamiliaresRamo?: string,
  ) {

    const classeProfissional = new ClasseProfissional();
    classeProfissional.id = idClasse;

    const profissao = new Profissao();
    profissao.id = idProfissao;

    const empresa = new Empresa();
    empresa.nome = nomeEmpresa;
    empresa.telefone = telefoneEmpresa;
    empresa.endereco = endereco;

    const tempoExperiencia = new TempoExperiencia();
    tempoExperiencia.valorNumerico = tempoExperienciaRamo;

    const dados = new DadosProfissionais();
    dados.classeProfissional = classeProfissional;
    dados.profissao = profissao;
    dados.empresa = empresa;
    dados._isSelectDados = true;
    dados.tempoExperiencia = tempoExperiencia;
    dados.familiaresRamo = possuiFamiliaresRamo;
    return dados;
  }

  public get idClasseProfissional(): number {
    return this.classeProfissional ? this.classeProfissional.id : undefined;
  }

  public get idProfissao(): number {
    return this.profissao ? this.profissao.id : undefined;
  }

  public get idGrupoProfissao(): number {
    return this.profissao ? this.profissao.idGrupoProfissao : undefined;
  }

  public get tempoExperienciaRamo(): number {
    return this.tempoExperiencia ? this.tempoExperiencia.valorNumerico : undefined;
  }

  public get nomeEmpresa(): string {
    return this.empresa ? this.empresa.nome : undefined;
  }

  public get telefoneEmpresa(): string {
    return this.empresa ? this.empresa.telefone : undefined;
  }

  get isEmpresa() {
    return this.classeProfissional && this.classeProfissional.empresa;
  }

  get valid(): boolean {
    return (this.classeProfissional && this.profissao && !this.isEmpresa) ||
    (this.classeProfissional && this.profissao && this.empresa && this.empresa.valid);
  }

  get validPesados(): boolean {
    return this.validaTempoExperiencia();
  }

  validaTempoExperiencia(): boolean {
    return this.tempoExperiencia !== null && this.tempoExperiencia !== undefined && this.tempoExperiencia.valorNumerico !== undefined;
  }

  get isSelectDados(): boolean {
    return this._isSelectDados;
  }

  dadosSelected() {
    this._isSelectDados = false;
  }
}
